const routeConstant = {
  login: {
    path: "/login",
    title: "Login",
  },
  dashboard: {
    path: "/dashboard/home",
    title: "Dashboard",
  },
  blogs: {
    path: "/dashboard/blogs",
    title: "Blogs",
  },
  images: {
    path: "/dashboard/images",
    title: "Images",
  },
  advertisement: {
    path: "/dashboard/advertisement",
    title: "Advertisement",
  },
  faqs: {
    path: "/dashboard/faqs",
    title: "FAQs",
  },
  policy: {
    path: "/dashboard/policy",
    title: "Policy",
  },
  testimonials: {
    path: "/dashboard/testimonials",
    title: "Testimonials",
  },
  brands: {
    path: "/dashboard/makes",
    title: "Makes",
  },
  settings: {
    path: "/dashboard/settings",
    title: "Settings",
  },
  users: {
    path: "/dashboard/users",
    title: "Users",
  },
  registrationRequests: {
    path: "/dashboard/registrationRequests",
    title: "Registration Requests",
  },
  powerSellerRequests: {
    path: "/dashboard/powerSellerRequests",
    title: "Power Seller Requests",
  },
  paymentTransactions: {
    path: "/dashboard/payment-transactions",
    title: "Payment",
  },
  subcriptionTransactions: {
    path: "/dashboard/subscription-transactions",
    title: "Subscription",
  },
  featureTransactions: {
    path: "/dashboard/feature-transactions",
    title: "Feature",
  },
  supportMessages: {
    path: "/dashboard/support",
    title: "Support Messages",
  },
  products: {
    path: "/dashboard/products",
    title: "Products",
  },
  userReport: {
    path: "/dashboard/user-reports",
    title: "Reported Users",
  },
  productReport: {
    path: "/dashboard/product-reports",
    title: "Reported Products",
  },
  flaggedUsers: {
    path: "/dashboard/flagged-users",
    title: "Flagged Users",
  },
};

export { routeConstant };
